import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export default function CTASection({ title, subtitle, accent = "cream" }) {
  const bgMap = {
    cream: "bg-[#FFF9E6]",
    pink: "bg-[#FFE4E8]",
    mint: "bg-[#E8F5E9]",
  };
  return (
    <section data-testid="cta-section" className={`${bgMap[accent]} relative overflow-hidden`}>
      <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-white/40 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-[#12b571]/8 blur-3xl pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-24 md:py-32 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#12b571]/10 text-black text-xs font-semibold mb-6">
          <Sparkles size={14} /> Free 14-day trial — no card required
        </div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-black tracking-tight">
          {title || "Ready to grow your business with Brivo?"}
        </h2>
        <p className="mt-6 text-lg text-black/70 max-w-2xl mx-auto leading-relaxed">
          {subtitle || "Join thousands of business owners selling smarter, tracking inventory in real-time, and getting paid faster."}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="https://brivopos.com/" data-testid="cta-get-started" className="btn-primary">
            Start free trial <ArrowRight size={18} />
          </Link>
          <Link to="/pricing" data-testid="cta-view-pricing" className="btn-secondary">
            View pricing
          </Link>
        </div>
      </div>
    </section>
  );
}
